__turbopack_context__.v({
  "content": "Weather-module-scss-module__Bhbjga__content",
  "contentLayout": "Weather-module-scss-module__Bhbjga__contentLayout",
  "date": "Weather-module-scss-module__Bhbjga__date",
  "section": "Weather-module-scss-module__Bhbjga__section",
});
